// @flow

export type ExperianResponseCodesType = 'RF1' | 'RF2' | 'RF3' | 'RF4' | 'ACC';
export type IdProofingEntityType = 'AGENT' | 'CONSUMER';
export type IdProofingChannelType = 'ONLINE' | 'TELEPHONE' | 'IN_PERSON';
export type IdProofingMethodType = 'RIDP_FARS' | 'DOCUMENT_REVIEW';
export type FollowUpOptionType = 'stride' | 'call-center' | 'redirect' | 'retry';
export const ID_TAG_NAME = 'ID Verify Document';

/* eslint-disable max-len */
export type IdVerifyDocType =
  | 'PLACEHOLDER'
  | 'CERTIFICATE_OF_NATURALIZATION'
  | 'SOCIAL_SECURITY_CARD'
  | 'DIVORCE_DECREE'
  | 'EMPLOYER_IDENTIFICATION_CARD'
  | 'IDENTIFICATION_CARD_ISSUED_BY_THE_FEDERAL_STATE_OR_LOCAL_GOVERNMENT'
  | 'U_S_COAST_GUARD_MERCHANT_MARINER_CARD'
  | 'PROPERTY_DEED_OR_TITLE'
  | 'SCHOOL_IDENTIFICATION_CARD'
  | 'VOTER_REGISTRATION_CARD'
  | 'DRIVER_S_LICENSE_ISSUED_BY_STATE_OR_TERRITORY'
  | 'U_S_MILITARY_CARD_OR_DRAFT_RECORD'
  | 'U_S_PASSPORT_OR_U_S_PASSPORT_CARD'
  | 'CERTIFICATE_OF_NATURALIZATION_FORM_N_550_OR_N_570_OR_US_CITIZENSHIP_FORM_N_560_OR_N_561'
  | 'PERMANENT_RESIDENT_CARD_OR_ALIEN_REGISTRATION_RECEIPT_CARD_FORM_I_551'
  | 'EMPLOYMENT_AUTHORIZATION_DOCUMENT_THAT_CONTAINS_A_PHOTOGRAPH_FORM_I_766'
  | 'MILITARY_DEPENDENT_S_IDENTIFICATION_CARD'
  | 'NATIVE_AMERICAN_TRIBAL_DOCUMENT'
  | 'FOREIGN_PASSPORT_OR_ID_ISSUED_BY_A_FOREIGN_EMBASSY_OR_CONSULATE_CONTAINS_A_PHOTOGRAPH'
  | 'HIGH_SCHOOL_OR_COLLEGE_DIPLOMA_INCLUDING_HIGH_SCHOOL_EQUIVALENCY_DIPLOMAS'
  | 'US_PUBLIC_BIRTH_REC'
  | 'MARRIAGE_CERTIFICATE';

export class EXPERIAN_RESPONSE_CODES {
  static ACC: ExperianResponseCodesType = 'ACC';
  static RF1: ExperianResponseCodesType = 'RF1';
  static RF2: ExperianResponseCodesType = 'RF2';
  static RF3: ExperianResponseCodesType = 'RF3';
  static RF4: ExperianResponseCodesType = 'RF4';
}

export class FOLLOWUP_OPTIONS {
  static STRIDE: FollowUpOptionType = 'stride';
  static CALL_CENTER: FollowUpOptionType = 'call-center';
  static REDIRECT: FollowUpOptionType = 'redirect';
  static RETRY: FollowUpOptionType = 'retry';
}

export class ID_PROOFING_ENTITY_TYPES {
  static AGENT: IdProofingEntityType = 'AGENT';
  static CONSUMER: IdProofingEntityType = 'CONSUMER';
}

export class ID_PROOFING_CHANNEL_TYPES {
  static ONLINE: IdProofingChannelType = 'ONLINE';
  static TELEPHONE: IdProofingChannelType = 'TELEPHONE';
  static IN_PERSON: IdProofingChannelType = 'IN_PERSON';
}

export class ID_PROOFING_METHOD_TYPES {
  static RIDP_FARS: IdProofingMethodType = 'RIDP_FARS';
  static DOCUMENT_REVIEW: IdProofingMethodType = 'DOCUMENT_REVIEW';
}

export const FOLLOWUP_ACTION_MAP = {
  [EXPERIAN_RESPONSE_CODES.RF1]: {
    stride: {
      pre: null,
      next: 'call-center',
    },
    'call-center': {
      pre: 'stride',
      next: 'redirect',
    },
    redirect: {
      pre: 'call-center',
      next: null,
    },
  },
  [EXPERIAN_RESPONSE_CODES.RF2]: {
    retry: {
      pre: null,
      next: 'stride',
    },
    stride: {
      pre: 'retry',
      next: 'call-center',
    },
    'call-center': {
      pre: 'stride',
      next: 'redirect',
    },
    redirect: {
      pre: 'call-center',
      next: null,
    },
  },
  [EXPERIAN_RESPONSE_CODES.RF3]: {
    stride: {
      pre: null,
      next: 'redirect',
    },
    redirect: {
      pre: 'stride',
      next: null,
    },
  },
  [EXPERIAN_RESPONSE_CODES.RF4]: {
    stride: {
      pre: null,
      next: 'redirect',
    },
    redirect: {
      pre: 'stride',
      next: null,
    },
  },
};

